module.exports = __webpack_public_path__ + "static/img/dialog.dba8a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/dialog.png
// module id = D97p
// module chunks = 0